import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import propTypes from "prop-types";
import axios from "axios";

const DealerInfo = ({ Id }) => {
  const [dealer, setDealer] = useState([]);

  const { id } = useParams();
  const url = `/api/content/dealers/${id || Id}`;
  console.log("id", id);
  useEffect(() => {
    const sendRequest = async () => {
      try {
        const response = await axios.get(url);
        const { data } = response;
        setDealer(data.data);
        console.log(response, data);
      } catch (err) {
        console.log(err);
      }
    };

    (id || Id) && sendRequest();
  }, [url]);
  console.log(dealer);
  return (
    <div className="App App-link">
      <h4>{dealer.attributes?.title}</h4>
      <p>{dealer.attributes?.contactNumber}</p>
      <p>{dealer.attributes?.address}</p>
    </div>
  );
};

export default DealerInfo;

DealerInfo.propTypes = {
  Id: propTypes.number,
};
